// extracted by mini-css-extract-plugin
module.exports = {"homePageCampaign":"HomeCampaign_homePageCampaign__8OEvg","fullWidthDesktop":"HomeCampaign_fullWidthDesktop__GRp8X","fullWidthMobile":"HomeCampaign_fullWidthMobile__1nlTN"};